import { render } from "./IconPhoto.vue?vue&type=template&id=71589482"
import script from "./IconPhoto.vue?vue&type=script&lang=js"
export * from "./IconPhoto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__